export const BUTTON_LABELS = {
  createMore: 'Create more',
  createMoreSubIssues: 'Create more sub-issues',
  createFullscreen: 'Open issue creation in fullscreen',
  copyUrl: 'Copy permalink',
  create: 'Create',
  cancel: 'Cancel',
}
